import type { TypePolicies } from '@apollo/client';

// These are assembled result rows, not facility/asset entities. Their membership
// and condition belong to a particular filter, cursor, scope and audience.
export const ASSET_HEALTH_BROWSER_CACHE_POLICIES: TypePolicies = {
    AssetHealthBrowserFacility: { keyFields: false },
    AssetHealthBrowserEquipment: { keyFields: false },
};
